<template>
  <div :style="{ transform: `rotate(${rotation}deg)`, scale, display: 'block' }">
    <v-chip size="x-small" v-if="containerCount > 1" :color="borderColor" class="container-counter">
      {{ containerCount }}
    </v-chip>
    <svg
      width="30"
      height="100"
      viewBox="0 0 30 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 2C2 0.895431 2.89543 -3.91405e-08 4 -8.74228e-08L26 -1.04907e-06C27.1046 -1.09736e-06 28 0.895429 28 2L2 2Z"
        :fill="borderColor" />
      <rect
        x="2.5"
        y="4.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="2.5"
        y="15.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="2.5"
        y="56.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="2.5"
        y="67.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <g clip-path="url(#clip0_4423_76557)">
        <mask id="path-6-inside-1_4423_76557" fill="white">
          <path d="M8 1H12V80H8V1Z" />
        </mask>
        <path d="M8 1H12V80H8V1Z" :fill="backgroundColor" />
        <path
          d="M11 1V80H13V1H11ZM9 80V1H7V80H9Z"
          :fill="borderColor"
          mask="url(#path-6-inside-1_4423_76557)" />
        <mask id="path-8-inside-2_4423_76557" fill="white">
          <path d="M18 1H22V80H18V1Z" />
        </mask>
        <path d="M18 1H22V80H18V1Z" :fill="backgroundColor" />
        <path
          d="M21 1V80H23V1H21ZM19 80V1H17V80H19Z"
          :fill="borderColor"
          mask="url(#path-8-inside-2_4423_76557)" />
      </g>
      <rect
        x="22.5"
        y="4.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="22.5"
        y="15.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="22.5"
        y="56.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <rect
        x="22.5"
        y="67.5"
        width="5"
        height="9"
        rx="0.5"
        :fill="borderColor"
        :stroke="borderColor" />
      <path d="M25 79V81H5V79H25Z" :fill="borderColor" />
      <path
        d="M3.5 89V88.5H3H2.5C1.94772 88.5 1.5 88.9477 1.5 89.5V91.5C1.5 92.0523 1.94772 92.5 2.5 92.5H3H3.5V92V89Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <path
        d="M26.5 81.5V97.2292C26.5 98.4939 25.5002 99.5 24.2903 99.5H5.70968C4.49977 99.5 3.5 98.4939 3.5 97.2292V81.5H26.5Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <path
        d="M26.5 92L26.5 92.5L27 92.5L27.5 92.5C28.0523 92.5 28.5 92.0523 28.5 91.5L28.5 89.5C28.5 88.9477 28.0523 88.5 27.5 88.5L27 88.5L26.5 88.5L26.5 89L26.5 92Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <g clip-path="url(#clip1_4423_76557)">
        <path
          d="M29.5 1.28571L29.5 77.7143C29.5 78.1748 29.1535 78.5 28.7838 78.5H1.21622C0.846476 78.5 0.5 78.1748 0.5 77.7143L0.5 1.28571C0.5 0.825233 0.846476 0.5 1.21622 0.5L28.7838 0.5C29.1535 0.5 29.5 0.825234 29.5 1.28571Z"
          :fill="backgroundColor"
          :stroke="borderColor" />
        <path
          d="M7.5 15.5V13.8333H9.16667V15.5H7.5ZM7.5 12.1667V10.5H9.16667V12.1667H7.5ZM10.8333 15.5V13.8333H12.5V15.5H10.8333ZM10.8333 12.1667V10.5H12.5V12.1667H10.8333ZM14.1667 15.5V13.8333H15.8333V15.5H14.1667ZM14.1667 12.1667V10.5H15.8333V12.1667H14.1667ZM17.5 15.5V13.8333H19.1667V15.5H17.5ZM17.5 12.1667V10.5H19.1667V12.1667H17.5ZM20.8333 15.5V13.8333H22.5V15.5H20.8333ZM20.8333 12.1667V10.5H22.5V12.1667H20.8333Z"
          :fill="borderColor" />
        <path
          d="M25.5 24C25.7761 24 26 24.2239 26 24.5C26 24.7761 25.7761 25 25.5 25H4.5C4.22386 25 4 24.7761 4 24.5C4 24.2239 4.22386 24 4.5 24H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 29C25.7761 29 26 29.2239 26 29.5C26 29.7761 25.7761 30 25.5 30H4.5C4.22386 30 4 29.7761 4 29.5C4 29.2239 4.22386 29 4.5 29H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 34C25.7761 34 26 34.2239 26 34.5C26 34.7761 25.7761 35 25.5 35H4.5C4.22386 35 4 34.7761 4 34.5C4 34.2239 4.22386 34 4.5 34H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 39C25.7761 39 26 39.2239 26 39.5C26 39.7761 25.7761 40 25.5 40H4.5C4.22386 40 4 39.7761 4 39.5C4 39.2239 4.22386 39 4.5 39H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 44C25.7761 44 26 44.2239 26 44.5C26 44.7761 25.7761 45 25.5 45H4.5C4.22386 45 4 44.7761 4 44.5C4 44.2239 4.22386 44 4.5 44H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 49C25.7761 49 26 49.2239 26 49.5C26 49.7761 25.7761 50 25.5 50H4.5C4.22386 50 4 49.7761 4 49.5C4 49.2239 4.22386 49 4.5 49H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 54C25.7761 54 26 54.2239 26 54.5C26 54.7761 25.7761 55 25.5 55H4.5C4.22386 55 4 54.7761 4 54.5C4 54.2239 4.22386 54 4.5 54H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 59C25.7761 59 26 59.2239 26 59.5C26 59.7761 25.7761 60 25.5 60H4.5C4.22386 60 4 59.7761 4 59.5C4 59.2239 4.22386 59 4.5 59H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 64C25.7761 64 26 64.2239 26 64.5C26 64.7761 25.7761 65 25.5 65H4.5C4.22386 65 4 64.7761 4 64.5C4 64.2239 4.22386 64 4.5 64H25.5Z"
          :fill="borderColor" />
        <path
          d="M25.5 69C25.7761 69 26 69.2239 26 69.5C26 69.7761 25.7761 70 25.5 70H4.5C4.22386 70 4 69.7761 4 69.5C4 69.2239 4.22386 69 4.5 69H25.5Z"
          :fill="borderColor" />
      </g>
      <defs>
        <clipPath id="clip0_4423_76557">
          <rect width="14" height="77" fill="white" transform="translate(8 2)" />
        </clipPath>
        <clipPath id="clip1_4423_76557">
          <rect width="30" height="79" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import BaseSvgSpotEntity from './BaseSvgSpotEntity.vue';

export default defineComponent({
  name: 'SvgTruckAssetContainerStriped',
  extends: BaseSvgSpotEntity,
  props: {
    containerCount: {
      type: Number,
      default: 1
    }
  }
});
</script>
<style lang="scss">
.container-counter {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
</style>
